export default function Infrastructure() {
    return (
        <section id="infrastructure" className="infrastructure-section">
            <div className="container">
                <h2 className="section-title">Company Infrastructure</h2>

                <div className="card infrastructure-card p-4">
                    <div className="row align-items-center">
                        <div className="col-md-7 mb-3">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.116452!2d72.741099!3d19.082197!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c63f06f1e6f1%3A0x6d6d3f6f6d6d6d6d!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1695800000000"
                                className="infrastructure-map"
                                allowFullScreen=""
                                loading="lazy"
                                title="Company Location"
                            ></iframe>
                        </div>
                        <div className="col-md-5">
                            <h5 className="infrastructure-title">Manufacturing Facilities</h5>
                            <p className="infrastructure-text">
                                Our company operates <strong>state-of-the-art manufacturing facilities</strong> in both <strong>Mumbai</strong> and <strong>Bhopal</strong> to ensure high-quality production, rigorous testing, and timely delivery for our clients.
                            </p>
                            <ul className="infrastructure-list">
                                <li><strong>Mumbai:</strong> Advanced assembly lines, quality control labs, and efficient logistics.</li>
                                <li><strong>Bhopal:</strong> Large-scale production units with warehouse and distribution support.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}
